import { styled } from "@mui/material";
import { GreenButton, Row, SmText } from "Components";
import { COLORS } from "constants/layout";
import { scrollToElement } from "helpers/browser";
import useBreakpoints from "hooks/useBreakpoint";
import { useIntl } from "react-intl";
import { useSelector } from "react-redux";
import { getOpenChat } from "redux/selectors/chat";

type Props = {};

const StickyBottomSection = (props: Props) => {
  const t = useIntl();
  const { isMobile } = useBreakpoints();
  const isOpenChat = useSelector(getOpenChat);

  return (
    <StyledStack textAlign="center" justifyContent="center" width={isOpenChat && !isMobile? "70%": "100%"}>
      <SmText>
        {t.formatMessage({
          id: isMobile
            ? "send_inquiry_connect_supplier"
            : "send_inquiry_now_connect_supplier",
        })}
      </SmText>

      <GreenButton
        sx={{ maxWidth: 124 }}
        onClick={() => scrollToElement("inquiry-form")}
      >
        {t.formatMessage({ id: "inquiry_now" })}
      </GreenButton>
    </StyledStack>
  );
};

const StyledStack = styled(Row)({
  position: "fixed",
  // width: "100%",
  zIndex: 1,
  backgroundColor: COLORS.green[25],
  left: 0,
  bottom: 0,
  padding: 10,
  boxSizing: "border-box",
  boxShadow: "0px 4px 6px 0px rgba(0, 0, 0, 0.25)",
  p: {
    span: {
      color: COLORS.green[600],
      fontWeight: 600,
    },
  },
  button: {
    whiteSpace: "nowrap",
  },
});

export default StickyBottomSection;
